module.exports = __webpack_public_path__ + "static/logo-9e9e460aafa7fc03bc363e7aa68c7aa7.svg";